import { useQuery } from '@tanstack/react-query'

import { accountClient } from '@/api'
import { config } from '@/config'

export const useUserSession = () => {
  const currentUserQuery = useQuery({
    queryKey: ['userSession'],
    queryFn: () => accountClient.getUserSession(),
    retry: 0,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: true,
    staleTime: config.requestsConfig.staleTime.userSession,
    refetchInterval: config.requestsConfig.intervals.userSession
  })

  return {
    currentUser: currentUserQuery.data,
    isFetching: currentUserQuery.isFetching,
    isReFetching: currentUserQuery.isRefetching
  }
}
